// LP · Help tracking: topic links glide to their FAQ group and flash its heading (the entrance
// animation is armed by a small inline script in the section). Uses event delegation, so it keeps
// working after the theme editor re-renders a section. No motion with prefers-reduced-motion.
(() => {
  if (window.lpHelpTrackReady) return;
  window.lpHelpTrackReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('[data-lph-track] .lp-help-track__topic') : null;
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (!url.hash || url.pathname !== window.location.pathname) return;
    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    const animate = !reduceMotion.matches && link.closest('.lp-help-track--motion');
    target.scrollIntoView({ behavior: animate ? 'smooth' : 'auto', block: 'start' });
    window.history.pushState(null, '', url.hash);
    if (!animate) return;
    // Flash the group once it has (nearly) arrived, so the cue is seen.
    const flash = () => {
      target.classList.remove('lph-landed');
      void target.offsetWidth;
      target.classList.add('lph-landed');
      window.setTimeout(() => target.classList.remove('lph-landed'), 1700);
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', flash, { once: true });
    else window.setTimeout(flash, 450);
  });
})();
